import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { defer, tap } from 'rxjs';
import { SERVER_DEBUG_LOG_ENABLED } from '@utils/logging-policy';
import { logServerError, logServerSuccess, nextServerLogId, toLogRequestObject } from '@utils/server-log';

export const httpBackendLogInterceptor: HttpInterceptorFn = (request, next) => {
  if (!SERVER_DEBUG_LOG_ENABLED) return next(request);
  return defer(() => {
    const id = nextServerLogId();
    const startedAt = Date.now();
    const method = `${request.method} ${request.url.split(/[?#]/)[0]}`;
    let payload: unknown;
    try {
      payload = toLogRequestObject(typeof request.body === 'string' ? JSON.parse(request.body) : request.body, method);
    } catch { /* Omit opaque bodies and unavailable diagnostic fields. */ }
    return next(request).pipe(tap({
      next: event => {
        try {
          if (event instanceof HttpResponse) {
            logServerSuccess('BACKEND HTTP', method, event.body, {
              id, request: payload, durationMs: Date.now() - startedAt, transport: { status: event.status },
            });
          }
        } catch { /* Preserve original response even if diagnostic access fails. */ }
      },
      error: error => {
        try {
          logServerError('BACKEND HTTP', method, {
            status: error?.status, message: error?.statusText, body: error?.error,
          }, { id, request: payload, durationMs: Date.now() - startedAt });
        } catch { /* Preserve original transport error. */ }
      },
    }));
  });
};
